// @flow
import React from 'react';
import { createUseStyles } from 'react-jss';
import SkeletonLoader from '@ff/ui/Skeleton/SkeletonLoader';

export default function Loader() {
  const c = useStyles();

  return (
    <div className={c.container}>
      <div className={c.innerContainer}>
        <SkeletonLoader variant="rectangular" height="100%" width="100%" />
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',

    width: '100%',
    height: '75vh',
    minHeight: '560px', /* Keep min-height the same as FutureSightLanding - imageLink */
    position: 'relative',
    '@media(max-width: 960px)': {
      height: '60vh',
    },
    '@media(max-height: 701px) and (max-width: 960px)': {
      height: '700px'
    }
  },
  innerContainer: {
    padding: '36px 36px 72px 36px',
    width: '70%',
    '@media(max-width: 1200px)': {
      width: '60%',
    },
    '@media(max-width: 960px)': {
      width: '100%',
    },
  }
};
const useStyles = createUseStyles(styles);
